import { Check } from "lucide-react";
import Reveal from "./Reveal";

export default function QhhtSession({ t }) {
  return (
    <section
      id="session"
      data-testid="services-section"
      className="py-28 md:py-40 bg-[#FDFBF7]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-20">
          <div className="lg:col-span-6">
            <Reveal>
              <span className="overline">{t.qhht.overline}</span>
            </Reveal>
            <Reveal delay={120}>
              <h2
                className="font-serif text-4xl md:text-5xl lg:text-6xl mt-5 leading-[1.05] text-[#3E362E] whitespace-pre-line"
                data-testid="services-title"
              >
                {t.qhht.title}
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 lg:pt-8">
            <Reveal delay={220}>
              <p className="text-[#5E554C] text-lg font-light leading-relaxed">
                {t.qhht.intro}
              </p>
            </Reveal>
          </div>
        </div>

        {/* QHHT session phases */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 border-t border-l border-[#E8E1D9]">
          {t.qhht.blocks.map((b, i) => (
            <Reveal key={b.tag} delay={i * 120}>
              <article
                className="service-card !border-t-0 !border-l-0 h-full min-h-[260px] flex flex-col"
                data-testid={`service-card-${i}`}
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="section-number">{b.tag}</span>
                  <span className="h-px w-16 bg-[#1A9BC1]" />
                </div>
                <h3 className="font-serif text-3xl md:text-4xl text-[#3E362E] mb-5 leading-tight">
                  {b.title}
                </h3>
                <p className="text-[#5E554C] text-base font-light leading-relaxed">
                  {b.desc}
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        {/* Highlights ribbon */}
        <Reveal delay={200}>
          <div
            className="mt-20 bg-[#F5EFE6] border border-[#E8E1D9] p-8 md:p-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-5"
            data-testid="qhht-highlights"
          >
            {t.qhht.highlights.map((h) => (
              <div key={h} className="flex items-start gap-3">
                <Check size={18} className="mt-1 text-[#1A9BC1] shrink-0" />
                <span className="text-[#3E362E] text-base font-light leading-snug">
                  {h}
                </span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
